module.exports = __webpack_public_path__ + "media/images/ln/horoscope_5-55306407df707bfe18ac8bedcbdbd836.png";